import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="mx-auto max-w-5xl px-4 pb-10 pt-7 text-center md:pb-12 md:pt-9" data-id="element-77">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55
    }} className="mx-auto mb-4 max-w-4xl text-3xl font-black leading-[1.08] tracking-tight text-brand-text sm:text-4xl md:text-5xl" data-id="element-78">
        Löse ein ganzes Jahr Yoga-Stunden in nur{' '}
        <span className="italic text-brand-green" data-id="element-79">5 Minuten</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.12,
      duration: 0.55
    }} className="mx-auto mb-4 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-80">
        Über 1.200 Yogalehrerinnen improvisieren nicht mehr. Komm in jede Stunde
        mit allem, was du zum Unterrichten, Vertiefen und Verwandeln brauchst.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.22,
      duration: 0.6
    }} className="relative mx-auto mb-5 w-full max-w-xl md:max-w-2xl" data-id="element-81">
        <img src="https://cdn.magicpatterns.com/uploads/mvRqgQWhcYKY2eQNFv5Gt5/ChatGPT_Image_14_jul_2026,_14_40_22-Photoroom.png" alt="Yoga Bereit Kit mit digitalen Jahresbänden auf verschiedenen Geräten" className="h-auto w-full object-contain" data-id="element-82" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.32,
      duration: 0.55
    }} data-id="element-83">
        <CTAButton onClick={scrollToPricing} className="mb-3 w-full sm:w-auto" data-id="element-84">
          ICH WILL DAS YOGA BEREIT KIT
        </CTAButton>
        <p className="text-xs font-medium text-brand-gray sm:text-sm" data-id="element-85">
          Sofortiger Download &middot; Kein Abo &middot; Lebenslanger Zugang
        </p>
      </motion.div>
    </section>;
}